import { Avatar } from "@/components/ui/misc";
import { useAvatarImage } from "@/lib/queries";
import type { AppUser } from "@/lib/types";

/**
 * A person's avatar: their profile picture once they have set one (ADR-079 in `platform`), and
 * their initials until then, while it loads, and whenever it cannot be fetched.
 */
export function UserAvatar({
  user, className,
}: {
  user: Pick<AppUser, "display_name" | "email" | "avatar_url">;
  className?: string;
}) {
  const src = useAvatarImage(user.avatar_url);
  return <Avatar name={user.display_name} email={user.email} src={src} className={className} />;
}

/**
 * Somebody else's avatar by their name and their picture's address, where a list or a chat has those
 * rather than their account: the picture once it loads, the initials until then and whenever it
 * cannot be read (a person the reader may not see answers 404, and stays initials).
 */
export function PictureAvatar({
  name, url, className,
}: {
  name: string | null | undefined;
  url: string | null | undefined;
  className?: string;
}) {
  const src = useAvatarImage(url);
  return <Avatar name={name ?? "?"} src={src} className={className} />;
}

